export function useLoading() {
  const value = ref(false)

  async function wrapLoading<T>(fn: () => Promise<T>): Promise<T | undefined> {
    if (value.value) {
      return
    }

    value.value = true
    try {
      return await fn()
    }
    finally {
      value.value = false
    }
  }

  return reactive({ value, wrapLoading })
}

export function useLoadingStates<T extends string | number = string>() {
  const loadingStates = ref<Record<T, ReturnType<typeof useLoading>>>({} as Record<T, ReturnType<typeof useLoading>>)

  function getLoadingState(id: T) {
    if (!loadingStates.value[id]) {
      loadingStates.value[id] = useLoading()
    }
    return loadingStates.value[id]
  }

  function clearLoadingState(id: T) {
    delete loadingStates.value[id]
  }

  function clearAllLoadingStates() {
    loadingStates.value = {} as Record<T, ReturnType<typeof useLoading>>
  }

  return {
    loadingStates,
    getLoadingState,
    clearLoadingState,
    clearAllLoadingStates,
  }
}
